import * as React from "react";
import { DepositMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/DepositMethod";
import { DirectDebitMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/DirectDebitMethod";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { BankAccountInstruction } from "../../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { MultiDownloadButton } from "../../../../../../Shared/DownloadButton/MultiDownloadButton";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { processTypeEnum } from "../../Resource/Contents";
import { SectionHeader } from "../../SharedComponents";
import { DirectDebitInstruction } from "./DirectDebitInstruction";

interface IDocumentsToSendProps extends IProcessComponentProps {
    data:
        | ApplyModel
        | GiaContributionModel
        | IsaContributionModel
        | PensionContributionModel
        | WrapCashContributionModel;
    processType: processTypeEnum;
    subAccountType: SubAccountType;
    needGoToDlu: boolean;
    selectAll: boolean;
    hideCheckBox?: boolean;
    triggerred: number;
    clAccountId?: string;
    onTasksForEsign: (newTask) => void;
}

interface IDocumentsToSend {}

export class DocumentsToSend extends ProcessComponent<IDocumentsToSendProps, IDocumentsToSend> {
    constructor(props: IDocumentsToSendProps) {
        super(props);
        this.state = {};
    }

    private hasChequePayment(model: any): boolean {
        return (
            model?.ClientSinglePayment?.PaymentMethod == DepositMethod.Cheque ||
            model?.ThirdPartySinglePayment?.PaymentMethod == DepositMethod.Cheque ||
            model?.EmployerSinglePayment?.PaymentMethod == DepositMethod.Cheque
        );
    }

    private displayRemittanceAdviceSlip(): boolean {
        const { data, processType } = this.props;
        if (this.props.needGoToDlu) {
            return false;
        }
        if (processType == processTypeEnum.SinglePaymentTransfer || processType == processTypeEnum.RegularPayment) {
            return this.hasChequePayment(
                (data as
                    | GiaContributionModel
                    | IsaContributionModel
                    | PensionContributionModel
                    | WrapCashContributionModel)?.Contribution
            );
        } else if (
            processType == processTypeEnum.NewBusiness ||
            processType == processTypeEnum.NewBusinessExistingClient
        ) {
            return (
                this.hasChequePayment((data as ApplyModel)?.GiaModel) ||
                this.hasChequePayment((data as ApplyModel)?.IsaModel) ||
                this.hasChequePayment((data as ApplyModel)?.PensionApply) ||
                this.hasChequePayment((data as ApplyModel)?.WrapCashModel)
            );
        }
    }

    private displayTermsAndConditions = () => {
        if (this.props.processType == processTypeEnum.NewBusiness && !this.props.needGoToDlu) {
            return true;
        }
        return false;
    };

    private displayTransferForm(): boolean {
        const { data, processType } = this.props;
        
        if (processType == processTypeEnum.SinglePaymentTransfer || processType == processTypeEnum.RegularPayment) {
            return (
                (data as GiaContributionModel).Contribution?.GiaTransfers?.length > 0 ||
                (data as IsaContributionModel).Contribution?.IsaTransfers?.length > 0 ||
                (data as PensionContributionModel).Contribution?.PensionTransfers?.length > 0
            );
        } else if (
            processType == processTypeEnum.NewBusiness ||
            processType == processTypeEnum.NewBusinessExistingClient
        ) {
            return (
                (data as ApplyModel).GiaModel?.GiaTransfers?.length > 0 ||
                (data as ApplyModel).IsaModel?.IsaTransfers?.length > 0 ||
                (data as ApplyModel).PensionApply?.PensionTransfers?.length > 0
            );
        }
    }

    private showDocumentsToSend(): boolean {
        const process = this.props.processType;
        
        if(process == processTypeEnum.PPToISA || process == processTypeEnum.PPToSIPP){
            return false;
        }

        return true;
    }

    render() {
        const { processType, data } = this.props;
        const props = {
            triggerred: this.props.triggerred,
            isSelectedAll: this.props.selectAll,
        };
        const params = getQueryParameters();
        const customerid = params["customerid"];
        const claccountid = this.props.clAccountId;
        const instructionId = params["id"];
        const headAccountHierarchyId = params["hierarchyid"];
        return ( this.showDocumentsToSend() &&
            <>
                {SectionHeader(
                    "Documents to send",
                    "These are documents you need to send us either by post or by using our e-sigs service. These documents will also appear in your client’s document store."
                )}
                {this.displayTermsAndConditions() && (
                    <MultiDownloadButton
                        fileName="Terms and conditions"
                        {...props}
                        data={null}
                        onChange={() => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        selectedAccount={null}
                        hideCheckbox={this.props.hideCheckBox}
                        request={DocumentsHelper.getTaskRequest(
                            instructionId,
                            null,
                            claccountid,
                            null,
                            DocumentTaskRequestTypeEnum.TermsAndCondition,
                            processType
                        )}
                        callBack={(taskRequestId: string) => {
                            this.props.onTasksForEsign({
                                fileName: "Terms and conditions",
                                taskRequestId: taskRequestId,
                            });
                        }}
                    />
                )}
                <DirectDebitInstruction {...this.props} />
                {this.displayRemittanceAdviceSlip() && (
                    <>
                        <MultiDownloadButton
                            fileName="Cheque Remittance Advice"
                            {...props}
                            data={null}
                            onChange={() => {}}
                            onRef={(ref) => this.appendChild(ref)}
                            request={DocumentsHelper.getTaskRequest(
                                processType == processTypeEnum.NewBusinessExistingClient
                                    ? data?.OwnerHierarchyId
                                    : instructionId,
                                customerid,
                                claccountid,
                                headAccountHierarchyId,
                                DocumentTaskRequestTypeEnum.RemittanceAdviceSlip,
                                processType
                            )}
                            hideCheckbox={this.props.hideCheckBox}
                            selectedAccount={headAccountHierarchyId}
                            tooltip={`For the cheque payment, your client needs to write ${this.props.clAccountId} on the back
                            of their cheque`}
                        />
                    </>
                )}
                {this.displayTransferForm() && (
                    <>
                        <MultiDownloadButton
                            {...props}
                            data={null}
                            onChange={() => {}}
                            onRef={(ref) => this.appendChild(ref)}
                            fileName="Scrip transfer form"
                            request={DocumentsHelper.getTaskRequest(
                                instructionId,
                                customerid,
                                claccountid,
                                headAccountHierarchyId,
                                DocumentTaskRequestTypeEnum.TransferForm,
                                processType
                            )}
                            hideCheckbox={this.props.hideCheckBox}
                            selectedAccount={headAccountHierarchyId}
                            callBack={(taskRequestId: string) => {
                                this.props.onTasksForEsign({
                                    fileName: "Scrip transfer form",
                                    taskRequestId: taskRequestId,
                                });
                            }}
                        />
                    </>
                )}
            </>
        );
    }
}
